import React from 'react';

export default class MarkerDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			is: -1,
			markerDetails: {
				markerObject: {
					id: -1,
					latitude: 0,
					longtitude: 0,
					title: '',
					content: '',
					image: null
				},
				directionsResponse: null
			}
		};

		this.receiveData = this.receiveData.bind(this);
		props.messenger.subscribe('send-data-to-box', this.receiveData);
	}

	receiveData(markerDetails) {
		// console.log(markerDetails);
		let newState = Object.assign(this.state, {
			markerDetails: markerDetails
		});

		this.setState(newState);

		// console.log('receiveData new state is');
		// console.log(markerDetails);
	}

	render() {
		let visibleClass = this.props.visible === false ? "" : " visible";
		let boxClass = 'marker-details-box' + visibleClass;
		let carTime = "";
		let bikeTime = "";

		if(this.state.markerDetails.directionsResponse) {
			carTime = this.props.markerDetails.directionsResponse.carResponse.routes[0].legs[0].duration.text;
			bikeTime = this.props.markerDetails.directionsResponse.bikeResponse.routes[0].legs[0].duration.text;
		}

		// console.log('directions service response is: ');
		// console.log(this.state.markerDetails.directionsResponse);
		// console.log('marker details are: ');
		// console.log(this.state.markerDetails);
		// console.log('marker props are: ');
		// console.log(this.state);

		return (
			<div id="super-awesome-show-me" className={boxClass}>
				<h2>{this.state.markerDetails.markerObject.Location}</h2>
				<span className="marker-info-close-btn" onClick={this.props.onCloseButtonPressed}>X</span>

				<div className="amenity_info-travel_container">
					<div className="amenity_info-travel amenity_info-travel--car">
						<img src="https://storage.googleapis.com/interactive-kallo.appspot.com/assets/location/car--gray.png" alt="car" />
						<span>{carTime}</span>
					</div>

					<div className="amenity_info-travel amenity_info-travel--bike">
						<img src="https://storage.googleapis.com/interactive-kallo.appspot.com/assets/location/bike--gray.png" alt="bike" />
						<span>{bikeTime}</span>
					</div>
				</div>
			</div>
		);
	}
}

MarkerDetails.propTypes = {
	markerDetails: React.PropTypes.shape({
		markerObject: React.PropTypes.object,
		directionsResponse: React.PropTypes.object
	}),
	visible: React.PropTypes.bool,
	messenger: React.PropTypes.object
};

MarkerDetails.defaultProps = {
	markerDetails: {
		markerObject: {
			id: -1,
			latitude: 0,
			longtitude: 0,
			title: '',
			content: '',
			image: null
		},
		directionsResponse: null
	}
};


/** WEBPACK FOOTER **
 ** ./src/modules/location/elements/MarkerDetails.js
 **/